import nanostyled from 'nanostyled';

export const Container = nanostyled('div', {
  base: '',
  flex: null,
  width: 'max-w-xl lg:max-w-2xl px-16 py-8',
  override: 'w-full',
});
